export const FEATURES_HOME = [
  {
    id: 'circuit',
    title: 'Une course, pas une liste de questions',
    text: "Tes élèves voient leur kart avancer à chaque bonne réponse. Ils voient les autres aussi. Le résultat : une attention qui ne décroche pas, même en fin d'heure.",
    image: 'quiz-course-telephone-et-pc.webp',
    imageAlt: 'Circuit de course KartQuiz avec classement en temps réel',
    width: 1000, height: 700,
  },
  {
    id: 'bonus',
    title: 'Des bonus qui changent la partie',
    text: "Banane sur le circuit, booster, ralentir le 1er, réduire le temps de réponse de l'adversaire… Les bonus rebattent les cartes. Le meilleur de la classe ne gagne pas toujours — et c'est tant mieux pour la motivation des autres.",
    image: 'quiz-kart-bonus.webp',
    imageAlt: 'Les bonus KartQuiz : banane, bouclier, turbo, gel',
    width: 1000, height: 700,
  },
  {
    id: 'ai',
    title: "L'IA crée tes quiz à ta place",
    text: "« Quiz de 15 questions sur la Révolution française niveau 4ème. » L'IA s'occupe du reste. Tu relis, tu ajustes, tu lances. Fini les soirées à taper des QCM.",
    image: 'quiz-genere-par-ia.webp',
    imageAlt: 'Interface de génération de quiz par IA dans KartQuiz',
    width: 1000, height: 700,
  },
  {
    id: 'kahoot',
    title: 'Tes quiz Kahoot deviennent des courses de kart',
    text: "Tu as déjà des quiz sur Kahoot ? Colle l'URL, et toutes tes questions arrivent dans KartQuiz en quelques secondes. Bonus, attaques, vitesse adaptative — la même révision, mais personne ne lâche son téléphone.",
    image: 'quiz-importer-kahoot-course.webp',
    imageAlt: 'Import de quiz Kahoot dans KartQuiz en 1 clic',
    width: 1000, height: 700,
  },
  {
    id: 'repetition',
    title: 'Les mauvaises réponses reviennent',
    text: "Quand un élève se trompe, KartQuiz lui redonne la bonne réponse — et la question revient plus tard dans la partie. Apprentissage par répétition, sans qu'il y pense.",
    image: 'quiz-apprendre-par-repetition.webp',
    imageAlt: 'Logique de répétition espacée dans KartQuiz',
    width: 1000, height: 700,
  },
  {
    id: 'synthese',
    title: 'Tu vois tout, eux aussi',
    text: "À la fin de la course, chaque élève reçoit sa synthèse : ce qu'il maîtrise, ce qu'il connaît, ce qu'il doit réviser en priorité. Toi, tu as la vue d'ensemble : les notions qui coincent pour toute la classe.",
    image: 'quiz-synthese-des-revisions.webp',
    imageAlt: 'Synthèse pédagogique de fin de partie KartQuiz',
    width: 1000, height: 700,
  },
]

export const STEPS_HOME = [
  {
    num: '1',
    icon: '✏️',
    title: 'Crée ton quiz',
    text: "Tape ton sujet, l'IA génère le quiz. Colle une URL Kahoot pour récupérer tes questions en 1 clic. Ou pioche dans la bibliothèque communauté.",
    image: 'quiz-pedagogique-genere-par-ia.webp',
    imageAlt: "Interface de création d'un quiz pédagogique généré par l'IA dans KartQuiz — quelques secondes suffisent à partir d'un simple sujet",
    imageTitle: "KartQuiz : créez votre quiz pédagogique avec l'intelligence artificielle",
    width: 2560, height: 1300,
  },
  {
    num: '2',
    icon: '📱',
    title: 'Lance la partie',
    text: "Affiche le code. Tes élèves le flashent depuis leur téléphone. Aucune inscription, aucune app.",
    image: 'quiz-multijoueurs-qrcode.webp',
    imageAlt: "Lancement d'un quiz multijoueurs en classe via QR code dans KartQuiz — les élèves rejoignent instantanément depuis leur téléphone, sans inscription ni application",
    imageTitle: "KartQuiz : lancez votre quiz multijoueurs en classe avec un simple QR code",
    width: 2560, height: 1300,
  },
  {
    num: '3',
    icon: '🏎️',
    title: "C'est parti",
    text: "Chaque bonne réponse fait avancer leur kart. Bonus, attaques, dépassements. Tu vois tout en direct sur grand écran.",
    image: 'quiz-interactif-course-kart.webp',
    imageAlt: "Course de karts interactive en temps réel sur KartQuiz — les élèves avancent sur le circuit à chaque bonne réponse, avec bonus et attaques",
    imageTitle: "KartQuiz : un quiz interactif sous forme de course de kart pour réviser en s'amusant",
    width: 2560, height: 1300,
  },
]

export const FOR_WHO = [
  {
    level: 'Collège',
    emoji: '📚',
    text: "Réviser le brevet, dynamiser un cours d'histoire ou de SVT, contrôler les acquis sans stress.",
  },
  {
    level: 'Lycée',
    emoji: '🎒',
    text: "Préparer le bac, fixer le vocabulaire en LV, transformer une fin d'heure en révisions.",
  },
  {
    level: 'Supérieur',
    emoji: '🎓',
    text: 'Réviser des concepts denses en éco, en droit, en médecine. Animer un TD à 30 étudiants.',
  },
]

export const STATS_ROW = [
  { value: '100%', label: 'gratuit pendant la bêta' },
  { value: '+200', label: 'parties jouées' },
  { value: '2 min', label: 'pour lancer une partie' },
]
